import { IWidgetDefinition, IWidget } from '../../common/core';
import { ListData, IListSettings } from '../list.widget/list';
import ListWidgetDefinition from '../list.widget/list';

var template = require("./fuse-list.html");
var styles = require("./fuse-list.scss").toString();

export interface IFuseListSettings extends IListSettings {
    debug?: true;
}

class FuseListData extends ListData {

    hasFilters: boolean;
    searchTerm: string;

    constructor(public widget: IWidget<FuseListData, IFuseListSettings, null>) {
        super(widget);
    }

    getSearchWidget(): any {
        var res = null;
        this.widget.service.getAllWidgets().forEach(function (w) {
            switch (w.type) {
                case 'fuse-search':
                    res = w;
                    break;
            }
        });
        return res;
    }

    getFiltersWidget(): any {
        var res = null;
        this.widget.service.getAllWidgets().forEach(function (w) {
            switch (w.type) {
                case 'fuse-subfilters':
                    res = w;
                    break;
            }
        });
        return res;
    }

    beforeSearch(): void {
        super.beforeSearch();

        var searchW = this.getSearchWidget();
        var subfiltersW = this.getFiltersWidget();
        this.hasFilters = subfiltersW?.data.getFilters().length;
        this.searchTerm = searchW?.state?.searchString;
    }

    clearFilters() {
        var subfiltersW = this.getFiltersWidget();
        subfiltersW.data.clearFilters();
    }

    clearSearchTerm() {
        var searchW = this.getSearchWidget();
        searchW.state.searchString = null;
        this.widget.service.setState();
    }

    trackAction(item) {
        var cfg = this.widget.service.getConfig();
        if (cfg.trackAction && this.widget.service.getGlobalOptions()['tracker']) {
            cfg.trackAction('fuse-list:itemClick', this.widget, {
                item: item
            });
        }
    }

    isDebugMode() {
        return this.widget.settings.debug && this.widget.service.getGlobalOptions().source == 'editor';
    }
}

var fuseWidgetDefinition: IWidgetDefinition<FuseListData, IFuseListSettings, null> = Object.assign(
    {},
    ListWidgetDefinition,
    {
        init(widget) {
            widget.data = new FuseListData(widget);
        },
        getFields(widget) {
            var fields = ListWidgetDefinition.getFields(widget);
            if (widget.data.isDebugMode()) {
                var res = ['_score'];
                if (fields) {
                    res.push(<any>fields);
                }
                return res.join(',');
            }
            return fields;
        },
        template: template,
        styles: styles
    });
export default fuseWidgetDefinition;